import type { SiteContent } from '../../content/types';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface MapCardProps {
  content: SiteContent;
}

export function MapCard({ content }: MapCardProps): JSX.Element {
  return (
    <Card className="overflow-hidden bg-white" id="anfahrt">
      <CardHeader className="space-y-2">
        <CardTitle>{content.contactPage.mapCard.headline}</CardTitle>
        <p className="text-sm text-[color:var(--color-muted)]">{content.contactPage.mapCard.text}</p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="overflow-hidden rounded-xl border border-[color:var(--color-border)]">
          <iframe
            src={content.contact.googleMapsEmbedUrl}
            title={content.contactPage.mapCard.headline}
            className="h-80 w-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <div className="flex flex-wrap gap-3">
          <Button asChild>
            <a href={content.contactPage.mapCard.primaryCta.href} target="_blank" rel="noreferrer">
              {content.contactPage.mapCard.primaryCta.label}
            </a>
          </Button>
          <Button asChild variant="outline">
            <a href={content.contactPage.mapCard.secondaryCta.href}>{content.contactPage.mapCard.secondaryCta.label}</a>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
